import axios from "../../plugins/axios"


export default {
    async getAllIncomeCategories() {
     const categories = await axios.getData("/auth/get-all-income-categories",  localStorage.getItem("token"))
        return categories;
    },
}